import { baseURL } from "../api/http.api";

const urlParams = new URLSearchParams(window.location.search);
export const APP_CONSTANTS = {
  base_url: "https://kodiak-backend-api-7iodz.ondigitalocean.app/",
  //baseAPPURL: "https://k-des-1.vercel.app/",
  baseAPPURL: "https://design.kodiak-wholesale.com/",
  // baseAPPURL: "http://localhost:3000/",
  
  placeholder_image: "placeholder.svg",
  view_api: "front-design/product-view-designer/",
  product_color_api: "front/product-variant/" + urlParams.get("sku"),
  uploadImage: "front/upload-user-image",
  removeBackgroundNew: "front/remove-background",
  removeBackground: "https://podcustomizer.com/api/REST_rembg",
  product_detail_api: "catalog_product/",
  propToExport: [
    "id",
    "unique_id",
    "is_remove_background",
    "des_upload_src",
    "org_upload_src",
    "org_bg_rem_src",
    "des_bg_rem_src",
    "originalImg",
    "remove_background_data",
    "invert_color",
  ],
};
